import styled from 'src/styles'

export const Wrapper = styled.div`
  width: 100%;
  height: calc(
    100% - 64px - 20px - 69px - 26px
  ); // saveopenbar + saveopenbar mb + history + footer
  transition: width linear 200ms;
`
